<div class="contenedorLogin pt-4">
  <div *ngIf="flgLoadLoginForm">
    <div class="loginFormulario">
      <div class="row">
        <div class="logo">
            <img src="assets/img/logo.png" alt="logo" width="89" />
        </div>
      </div>
      <div class="row">
          <h3>Sistema de Control de Plataforma</h3>
      </div>
      <div class="row">
        <p-button type="button" (onClick)="fnLogin()" [label]="labelBtnInicio" [disabled]="flgIniciandoSesion" icon="pi pi-sign-in" />
      </div>
    </div>
  </div>
  <div *ngIf="!flgLoadLoginForm">
      <div class="loginCargando">
        <div class="row">
            <h4>Cargando.....</h4>
        </div>
      </div>
  </div>
</div>